import type { ArdoqId } from '@ardoq/api-types';
import type { HierarchyOfLinkedComponentsWithDirection } from '@ardoq/data-model';

export const isLinkToGroupingAncestor = (
  linkedComponent: HierarchyOfLinkedComponentsWithDirection,
  groupingAncestorIds: ReadonlySet<ArdoqId>
): boolean =>
  groupingAncestorIds.has(linkedComponent.componentId) &&
  linkedComponent.linkedComponents.length === 0;
